import moment from 'moment';
import Transformer from '../transformer';

export default class OneJobUpdate extends Transformer {
  /**
   * @param JobUpdated
   *
   * @returns {Object} The transformed job udapted
   */
  static send(job) {
    const slot = job.slots[0];
    const preSelectedStudents = () => {
      let students = [];
      let leaders = [];
      if (slot.chooseStudents && slot.chooseStudents.length) {
        students = slot.chooseStudents.map((item) => ({
          student: `/api/v3/students/${item.student.id}`,
          leader: false,
          confirmed_by_student: item.enabled,
        }));
      }

      if (slot.chooseStudentsLeaders && slot.chooseStudentsLeaders.length) {
        leaders = slot.chooseStudentsLeaders.map((item) => ({
          student: `/api/v3/students/${item.student.id}`,
          leader: true,
          confirmed_by_student: item.enabled,
        }));
      }
      return students.concat(leaders);
    };

    job.pre_selected_students = preSelectedStudents();

    const date = moment(job.slots[0].date);
    const hourBegin = moment(job.slots[0].hourBegin, 'HH:mm');
    const hourEnd = moment(job.slots[0].hourEnd, 'HH:mm');

    const dateHourBegin = moment(job.slots[0].date)
      .set({
        hour: hourBegin.get('hour'),
        minute: hourBegin.get('minute'),
      });
    const dateHourEnd = moment(job.slots[0].date)
      .set({
        hour: hourEnd.get('hour'),
        minute: hourEnd.get('minute'),
      });

    let types = [];
    if (job.type === 'home-office') {
      types = ['at_home'];
      delete job.address.geo_point;
      delete job.address.street;
      delete job.address.label;
      delete job.address.formatted_address;
      delete job.address.city;
      delete job.address.zip_code;
      delete job.address.country;
      delete job.latitude;
      delete job.longitude;
    } else if (!job.address.street) {
      // types = ['flexible_places'];
    }

    if (job.address.latitude === null || job.address.longitude === null) {
      job.address.geo_point = null;
    }
    // if (types[0] === 'flexible_places') {
    //   job.address.street = '';
    // }

    function removeEmpty(obj) {
      return Object.fromEntries(Object.entries(obj)
        // eslint-disable-next-line no-unused-vars
        .filter(([_, v]) => v != null));
    }

    job.address = removeEmpty(job.address);

    if (job.contacts) {
      job.address.contacts = job.contacts.filter((contact) => contact && contact.id).map((contact) => `/api/v3/contacts/${contact.id}`);
    }

    if (job.access) {
      job.address.comment = job.access !== '' ? job.access : null;
    }

    return {
      address: job.address,
      types,
      date: date.format(),
      hour_begin: dateHourBegin.format(),
      hour_end: dateHourEnd.format(),
      count_student_asked: job.slots[0].countStudents + job.slots[0].countLeaders,
      count_referer_asked: job.slots[0].countLeaders ? job.slots[0].countLeaders : 0,
      break_time_minutes: job.slots[0].pauseTime ? job.slots[0].pauseTime : 0,
      // eslint-disable-next-line no-nested-ternary
      lunch_meal_amount: job.slots[0].lunchType ? (job.slots[0].lunchType === 'given' ? 0 : (0 + parseFloat(String(job.slots[0].lunchType).replace(',', '.')))) : null,
      pre_selected_students: job.pre_selected_students,
      lunch_meal_given_by_customer: job.slots[0].lunchType === 'given',
      break_time_paid: job.slots[0].pauseType === 'paid',
    };
  }
}
